export const stateNames = [
    "andhra-pradesh",
    "arunachal-pradesh",
    "assam",
    "bihar",
    "chhattisgarh",
    "goa",
    "gujarat",
    "haryana",
    "himachal-pradesh",
    "jharkhand",
    "karnataka",
    "kerala",
    "madhya-pradesh",
    "maharashtra",
    "manipur",
    "meghalaya",
    "mizoram",
    "nagaland",
    "odisha",
    "punjab",
    "rajasthan",
    "sikkim",
    "tamil-nadu",
    "telangana",
    "tripura",
    "uttar-pradesh",
    "uttarakhand",
    "west-bengal",
    "andaman-and-nicobar-islands",
    "chandigarh",
    "dadra-and-nagar-haveli-and-daman-and-diu",
    "delhi",
    "jammu-and-kashmir",
    "ladakh",
    "lakshadweep",
    "puducherry"
]